import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Alert,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import {
    API_URL_GET_REPORT_DETAIL
} from '../../constants';

import axios from "axios";
import ReportFields from "./components/ReportFields";
import ReportContents from "./components/ReportContents";
import { 
    withRouter
} from "react-router-dom";
import { toast } from "react-toastify";
import { useQuery } from "@tanstack/react-query";
import Navigator from "src/components/navigator";
import Messages from "./components/Messages";
import UserUtils from "src/services/utils/UserUtils";

const ReportDetails = ({
    t,
    token,
    currentUser,
    history,
    location,
    match: {
        params = {}
    }
}) => {
    const urlSearchParams = new URLSearchParams(location.search);
    const activeTab = urlSearchParams.get('tab') || 'report_details';
    
    const { id: reportId } = params;

    const userUtils = new UserUtils();

    const {
        data: report,
        isFetching: fetchingReportDetails
    } = useQuery({
        queryKey: [
            'data-protection-fetch-report-details',
            reportId
        ],
        queryFn: async () => {
            const response = await axios.post(
                API_URL_GET_REPORT_DETAIL,
                {
                    report_case_id: reportId || localStorage.getItem('caseId'),
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );

            return response.data?.data;
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching report details.'), {
                type: 'error'
            });
        }
    });

    const handleTabClick = (tab) => {
        history.push({
            search: '?tab=' + tab
        })
    }

    return (
        <div className="page-content">
            <Container fluid>
                <Navigator  
                    breadCrumbs={[
                        { title: "SIP", link: "/" },
                        { title: t("Report"), link: "#" }
                    ]}
                    pageTitle={report?.secondary_case_id}
                />

                <Row>
                    <Col xl="12">
                        <Card>
                            <CardBody className="tabOverview">
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "report_details",
                                                customActiveNav: activeTab === "report_details"
                                            })}
                                            onClick={() => handleTabClick('report_details')}
                                            disabled={
                                                !report || report?.is_deleted_content
                                            }
                                        >
                                            <span className="d-block">
                                                {t("Report")}
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    
                                    {report && !report.is_deleted_content && (
                                        <NavItem hidden={!report.has_access_message}>
                                            <NavLink
                                                className={classnames({
                                                    active: activeTab === "messages",
                                                })}
                                                onClick={() => handleTabClick('messages')}
                                            >
                                                <span className="d-block">
                                                    {t("Messages")}
                                                </span>
                                            </NavLink>
                                        </NavItem>
                                    )}
                                </Nav>

                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="report_details" className="pt-4">
                                        <ReportFields
                                            isLoading={fetchingReportDetails}
                                            isEmployee={userUtils.isEmployee(currentUser)}
                                            isThirdParty={userUtils.isThirdParty(currentUser)}
                                            report={report}
                                        />

                                        {report ? (
                                            report.is_deleted_content ? (
                                                <Alert color="warning">
                                                    {t("This case is deleted.")}
                                                </Alert>
                                            ) : (
                                                <ReportContents
                                                    t={t}
                                                    questions={report?.question_answers}
                                                    reportLoading={report ? false : true}
                                                />
                                            )
                                        ) : null}
                                    </TabPane>

                                    <TabPane tabId='messages' className='pt-4'>
                                        <Messages 
                                            caseId={reportId}
                                            isReportDeleted={report?.is_deleted_content}
                                        />
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

const mapStatetoProps = (state) => {
    const { token, user: currentUser } = state.Login;

    return {
        token,
        currentUser
    };
};

export default withNamespaces()(
    withRouter(
        connect(mapStatetoProps)(
            ReportDetails
        )
    )
);
